import { render, staticRenderFns } from "./SignPlace.vue?vue&type=template&id=0962274b&scoped=true&"
import script from "./SignPlace.vue?vue&type=script&lang=js&"
export * from "./SignPlace.vue?vue&type=script&lang=js&"
import style0 from "./SignPlace.vue?vue&type=style&index=0&id=0962274b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0962274b",
  null
  
)

export default component.exports